import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { pdsCustomElement as customElement } from '../../decorators/pds-custom-element';
import { PdsElement } from '../PdsElement';
import styles from './nav-container.scss?inline';

/**
 * @summary This component is a container (nav) that holds the main nav and utility nav elements
 *
 * @slot default One or more pds-main-nav &/or utility nav elements
 */
@customElement('pds-nav-container', {
  category: 'component',
  type: 'component',
  styles,
})
export class PdsNavContainer extends PdsElement {
  /**
   * Style variant
   * - **default** renders the default primary-navigation
   * - **inverted** renders the inverted primary-navigation
   */
  @property()
  variant: 'default' | 'inverted';

  /**
   * @internal
   */
  get classNames() {
    return {
      /* This is equivalent to doing
       * 'default': this.variant === 'default',
       * 'inverted': this.variant === 'inverted',
       */
      [this.variant]: !!this.variant,
    };
  }

  render() {
    return html`<div class=${this.getClass()}>
      <div
        class="pds-c-nav-container__inner"
        @click=${(event: Event) => event.stopPropagation()}
      >
        <slot></slot>
      </div>
    </div>`;
  }
}
